export const DEFAULT_PAGE_SIZE = 100;

export const PAGE_OPTIONS = [10, 20, 50, 100, 500, 1000];
